export { ArrowsUpDown as default } from './ArrowsUpDown';
